import type { DataViewMode } from 'components/DataView';

import { BundlesDataTableView } from '../BundlesDataTableView';
import { BundlesTrelloView } from '../BundlesTrelloView';
import type { BundleRow } from './bundlesColumns';

/**
 * Les deux vues ne se connaissent pas : elles reçoivent les lignes déjà filtrées et l'API de sélection,
 * portées par la `DataView`. `render` est un champ de config, comme `ColumnDef.cell`.
 *
 * Le kanban est en tête, donc c'est la vue par défaut (`?view=` prime quand l'URL en porte une).
 *
 * Une fabrique plutôt qu'une constante : les deux vues prennent la pagination en paramètre — le kanban
 * la rend visible par un bouton, le tableau la consomme au défilement — et la page reste le seul
 * endroit qui connaisse la query.
 */
export function buildBundleViews({
    hasMore,
    isLoadingMore,
    onLoadMore,
}: {
    hasMore: boolean;
    isLoadingMore: boolean;
    onLoadMore: () => Promise<unknown>;
}): DataViewMode<BundleRow>[] {
    return [
        {
            key: 'kanban',
            label: 'Kanban',
            render: ({ rows, selection }) => (
                <BundlesTrelloView
                    bundles={rows}
                    selectedBundleIds={selection.selectedKeys}
                    setSelectedBundleIds={selection.setSelectedKeys}
                    toggleBundleSelection={selection.toggleKey}
                    hasMore={hasMore}
                    isLoadingMore={isLoadingMore}
                    onLoadMore={onLoadMore}
                />
            ),
        },
        {
            key: 'table',
            label: 'Tableau',
            render: ({ rows, selection }) => (
                <BundlesDataTableView
                    bundles={rows}
                    selectedBundleIds={selection.selectedKeys}
                    setSelectedBundleIds={selection.setSelectedKeys}
                    hasMore={hasMore}
                    onLoadMore={onLoadMore}
                />
            ),
        },
    ];
}
